import { jurisdictionConfig } from 'constants/jurisdictionConfigs'

import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translationEN from './locales/en/translation.json'
import translationZH from './locales/zh/translation.json'

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false
  }
}

const resources = {
  en: {
    translation: translationEN,
  },
  zh: {
    translation: translationZH,
  },
} as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: jurisdictionConfig().defaultLanguage,
    resources,
    supportedLngs: ['en', 'zh'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
